import React, { useState, useEffect } from "react";
import Baseurl from "../../../Baseurl";
import { Table, Col, Card,Spinner,Modal } from "react-bootstrap";
import axios from "axios";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
export default function ViewRestaurant(props) {
  const { id } = props.match.params;
  const history=useHistory()
  const [restaurantDetails, setRestaurantDetails] = useState("");
  const [commRate, setCommRate] = useState(0);
  const [restaurant, setRestaurant] = useState("");
  const [reason, setReason] = useState("");
  const [spinnerAccept, setSpinnerAccept] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show, setShow] = useState(false);
  const [rejectStatus, setRejectStatus] = useState(false);
  const [viewimage, setViewImage] = useState();
  const handleClose1 = () => {
    setShow1(false);
  };
  function getData() {
    axios
      .get(`${Baseurl.baseurl4}/go-food/get-retaurant-by-id/${id}`)
      .then((res) => {
        console.log("resto details", res.data);
        let restoArr = [];
        if (res.data.status) {
          setRestaurant(res.data.RestaurantDetails);
          restoArr.push(
            {
              name: "Restaurant Name",
              val: res.data.RestaurantDetails.RName,
            },
            {
              name: "Description",
              val: res.data.RestaurantDetails.RDescription,
            },
            {
              name: "Cuisines",
              val: res.data.RestaurantDetails.RCuisines,
            },
            {
              name: "Outlet Type",
              val: res.data.RestaurantDetails.ROutletType,
            },

            {
              name: "Type",
              val: res.data.RestaurantDetails.RPureVeg ? "Veg" : "Non-Veg",
            },
            {
              name: "Address",
              val: res.data.RestaurantDetails.RFullAddress,
            },
            {
              name: "Land Mark",
              val: res.data.RestaurantDetails.RLandmark,
            },
            {
              name: "Pincode",
              val: res.data.RestaurantDetails.RPincode,
            },
            {
              name: "Lattitude",
              val: res.data.RestaurantDetails.RLatitude,
            },
            {
              name: "Longittude",
              val: res.data.RestaurantDetails.RLongitude,
            },
            {
              name: "Approx Price For 2 Persons",
              val: res.data.RestaurantDetails.RApproxPriceForTwo,
            },
            {
              name: "Start Time",
              val: res.data.RestaurantDetails.RStartTime,
            },
            {
              name: "End Time",
              val: res.data.RestaurantDetails.REndTime,
            },
            {
              name: "Fssail Code",
              val: res.data.RestaurantDetails.RFssaiLicCode,
            },
            {
              name: "Fssail Expiry Date",
              val: res.data.RestaurantDetails.RFssaiLicExpiryDate,
            },
            {
              name: "Fssail Expiry Date",
              val: res.data.RestaurantDetails.RFssaiLicExpiryDate,
            }
          );
          console.log("ffkfkfkfkkfkfkf", restoArr);
          setRestaurantDetails(restoArr);
        }
      });
  }
  useEffect(() => {
    getData();
  }, []);
  function acceptRestaurant(){
    setSpinnerAccept(true);
    const params = { rID: id ,
      commissionRate:commRate
     // RegistrationToken:
    };
    axios
      .put(`${Baseurl.baseurl4}/go-food-super-admin/approve-restaurant-details`, params)
      .then((res) => {
        if (res.data.status) {
          swal("Accepted", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setSpinnerAccept(false);
          history.push("/Verified-Restaurant");
        } else {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }

      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  function viewImage(img) {
    setShow1(true);
    setViewImage(img);
  }
  function rejectRestaurant(){
    const params = { rID: id ,
      reason:reason
     // RegistrationToken:
    };
    axios
      .put(`${Baseurl.baseurl4}/go-food-super-admin/reject-restaurant-details`, params)
      .then((res) => {
        if (res.data.status) {
          swal("Rejected", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          history.push("/Verified-Restaurant");
        } else {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }

      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  return (
    <div>

      <Col lg={12}>
      <Modal size="lg" show={show} onHide={()=>{setShow(false)}}>
        <Modal.Body>
        <div className="row">
             <div className="col-sm-2 mt-2">
                    <label>Commisssion</label>
                  </div>
                  <div className="col-sm-8 ">
                    <textarea
                      type="number"
                      className="form-control"
                      id="val-username"
                      name="val-username"
                      value={commRate}
                      onChange={(e) => setCommRate(e.target.value)}
                      placeholder="Enter Commission"
                    />
                  </div>
           </div>
         
        </Modal.Body>
        <Modal.Footer>
           <button onClick={()=>{acceptRestaurant()}} className="btn btn-primary">Accept</button>
         </Modal.Footer>
       
      </Modal>
      <Modal size="lg" show={show1} onHide={handleClose1}>
        <Modal.Body>
          {rejectStatus?(
           <div className="row">
             <div className="col-sm-2 mt-2">
                    <label>Reason</label>
                  </div>
                  <div className="col-sm-8 ">
                    <textarea
                      type="text"
                      className="form-control"
                      id="val-username"
                      name="val-username"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      placeholder="Enter reason"
                    />
                  </div>
           </div>
          ):( <div>
            <img
              alt=""
              style={{
                resizeMode: "cover",
                width: "100%",
                height: "100%",
              }}
              className="playerProfilePic_home_tile"
              src={viewimage}
            />
          </div>)}
         
        </Modal.Body>
        {rejectStatus&&(
           <Modal.Footer>
           <button onClick={()=>{rejectRestaurant()}} className="btn btn-danger">Reject</button>
         </Modal.Footer>
        )}
       
      </Modal>
        <Card
          style={{
            color: "white",
            background:
              "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
          }}
        >
           <Card.Header>
             <div></div>
            <button className="btn btn-primary " onClick={()=>{history.goBack()}}>Back</button>
           </Card.Header>
          <Card.Body>
            <Table className="text-white">
            {restaurantDetails &&
                  restaurantDetails.map((val) => {
                    return (
                      <tr>
                        <td>{val.name}</td>
                        <td>{val.val}</td>
                      </tr>
                    );
                  })}
            </Table>
            <div className="basic-form">
        <div className="row mt-4">
          <div className="col-sm-3">
            <label>
              Fassail Image
            </label>
          </div>
          <div classname="col-sm-4">
            <div className="register_profile_image  ml-5  ">
              {/* <input
                        required
                        id="profilePic"
                        type="file"
                        onChange={(e) => {
                          onChangePicture(e, "fssail");
                        }}
                      /> */}
            </div>
            {restaurant.RFssaiLicImage && (
              <div
              onClick={() => {
                viewImage(restaurant.RFssaiLicImage);
              }}
                style={{
                  marginTop: "5px",
                  width: 180,
                  height: 100,
                  aspectRatio: 1 * 1.4,
                }}
                className="previewProfilePic"
              >
                <img
                  alt=""
                  className="playerProfilePic_home_tile"
                  style={{
                    resizeMode: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                  src={restaurant.RFssaiLicImage}
                />
              </div>
            )}
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-sm-3">
            <label>
              Restaurant Image 
            </label>
          </div>
          <div classname="col-sm-2">
            {restaurant.RImage && (
              <div
              onClick={() => {
                viewImage(restaurant.RImage);
              }}
                style={{
                  marginTop: "5px",
                  width: 180,
                  height: 100,
                  aspectRatio: 1 * 1.4,
                }}
                className="previewProfilePic"
              >
                <img
                  alt=""
                  className="playerProfilePic_home_tile"
                  style={{
                    resizeMode: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                  src={restaurant.RImage}
                />
              </div>
            )}
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-sm-3">
            <label>
              Menu Images
            </label>
          </div>
          <div classname="col-sm-4">
            <div className="register_profile_image  ml-3"></div>
            <div className="row">
              {restaurant.RMenuImage &&
                restaurant.RMenuImage.map((val) => {
                  return (
                    <div
                    onClick={() => {
                      viewImage(val);
                    }}
                      style={{
                        marginTop: "5px",
                        width: 180,
                        height: 100,
                        aspectRatio: 1 * 1.4,
                      }}
                      className="previewProfilePic col-sm-4"
                    >
                      <img
                        alt=""
                        className="playerProfilePic_home_tile"
                        style={{
                          resizeMode: "cover",
                          width: "100%",
                          height: "100%",
                        }}
                        src={val}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
          </Card.Body>
          {!restaurant.RVerified&&!restaurant.Blocked && (
             <Card.Footer>
               {spinnerAccept ? (
              <div className="ml-auto mr-2 float-right">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <>
              
              {restaurant&&restaurant.RCategoryList.length!==0?<button className="btn btn-primary float-right" onClick={()=>{setShow(true)}}>Accept</button>:<div className="text-danger">Items Not Added Yet</div>}
              </>
            )}
           
             <button onClick={()=>{
              setRejectStatus(true)
              setShow1(true)}} className="btn btn-danger text-center ">Reject</button>
           </Card.Footer>
          )}
         
        </Card>

      </Col>

    
    </div>
  );
}
